import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { isDateAfterToday } from '@/utils/datetime';
import { halfPieChartSettings, powerChartSettings } from './chartSettings';
import Highcharts from 'highcharts';
import { getPowerGenPowerUsageApi } from '@/api/energy';
import { isNumber } from '@/utils/is';

import clonedeep from 'lodash.clonedeep';
import dayjs from 'dayjs';
export default {
  name: 'OverviewPowerGeneration',
  props: {
    selectedFieldName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      datePickerOpen: false,
      selectedDate: new Date(),
      hourlyData: [],
      // for halfPie
      dailyData: {},
      // for powerChart
      pvHalfPieChartOptions: _objectSpread(_objectSpread({}, clonedeep(halfPieChartSettings)), {}, {
        series: [{
          data: [null, null]
        }] // data 內數值總和 100%
      }),
      powerHalfPieChartOptions: _objectSpread(_objectSpread({}, clonedeep(halfPieChartSettings)), {}, {
        series: [{
          data: [null, null]
        }] // data 內數值總和 100%
      }),
      powerChartOptions: _objectSpread(_objectSpread({}, powerChartSettings), {}, {
        series: []
        // series: [
        //   {
        //     name: '用電',
        //     data: []
        //   },
        //   {
        //     name: '綠電自發自用',
        //     data: []
        //   },
        //   {
        //     name: '餘電躉售',
        //     data: []
        //   }
        // ]
      })
    };
  },
  computed: {
    powerData: function powerData() {
      var _this$dailyData, _this$dailyData$pv, _this$dailyData2, _this$dailyData2$pv, _this$dailyData3, _this$dailyData3$pv, _this$dailyData4, _this$dailyData4$pv, _this$dailyData5, _this$dailyData5$powe, _this$dailyData6, _this$dailyData6$powe, _this$dailyData7, _this$dailyData7$powe, _this$dailyData8, _this$dailyData8$powe;
      return {
        pv: {
          title: '光電發電量',
          greenValue: isNumber((_this$dailyData = this.dailyData) === null || _this$dailyData === void 0 ? void 0 : (_this$dailyData$pv = _this$dailyData.pv) === null || _this$dailyData$pv === void 0 ? void 0 : _this$dailyData$pv.selfPower) ? Math.round(((_this$dailyData2 = this.dailyData) === null || _this$dailyData2 === void 0 ? void 0 : (_this$dailyData2$pv = _this$dailyData2.pv) === null || _this$dailyData2$pv === void 0 ? void 0 : _this$dailyData2$pv.selfPower) * 100) / 100 : '-',
          utilityValue: isNumber((_this$dailyData3 = this.dailyData) === null || _this$dailyData3 === void 0 ? void 0 : (_this$dailyData3$pv = _this$dailyData3.pv) === null || _this$dailyData3$pv === void 0 ? void 0 : _this$dailyData3$pv.sellPower) ? Math.round(((_this$dailyData4 = this.dailyData) === null || _this$dailyData4 === void 0 ? void 0 : (_this$dailyData4$pv = _this$dailyData4.pv) === null || _this$dailyData4$pv === void 0 ? void 0 : _this$dailyData4$pv.sellPower) * 100) / 100 : '-',
          greenTitle: '綠電自發自用',
          utilityTitle: '餘電躉售',
          chartOption: this.pvHalfPieChartOptions
        },
        power: {
          title: '用電電量',
          greenValue: isNumber((_this$dailyData5 = this.dailyData) === null || _this$dailyData5 === void 0 ? void 0 : (_this$dailyData5$powe = _this$dailyData5.power) === null || _this$dailyData5$powe === void 0 ? void 0 : _this$dailyData5$powe.selfPower) ? Math.round(((_this$dailyData6 = this.dailyData) === null || _this$dailyData6 === void 0 ? void 0 : (_this$dailyData6$powe = _this$dailyData6.power) === null || _this$dailyData6$powe === void 0 ? void 0 : _this$dailyData6$powe.selfPower) * 100) / 100 : '-',
          utilityValue: isNumber((_this$dailyData7 = this.dailyData) === null || _this$dailyData7 === void 0 ? void 0 : (_this$dailyData7$powe = _this$dailyData7.power) === null || _this$dailyData7$powe === void 0 ? void 0 : _this$dailyData7$powe.buyPower) ? Math.round(((_this$dailyData8 = this.dailyData) === null || _this$dailyData8 === void 0 ? void 0 : (_this$dailyData8$powe = _this$dailyData8.power) === null || _this$dailyData8$powe === void 0 ? void 0 : _this$dailyData8$powe.buyPower) * 100) / 100 : '-',
          greenTitle: '綠電自發自用',
          utilityTitle: '外購電力',
          chartOption: this.powerHalfPieChartOptions
        }
      };
    }
  },
  watch: {
    selectedFieldName: function selectedFieldName() {
      this.selectedDate = new Date();
      this.getPowerGenPowerUsageData();
    }
  },
  methods: {
    isDateAfterToday: isDateAfterToday,
    observeElementSize: function observeElementSize() {
      this.resizeObserver = new ResizeObserver(function (_entries) {
        Highcharts.charts.forEach(function (chart) {
          if (chart && chart.renderTo.id === 'powerChartId') {
            chart.reflow();
          }
          // if (
          //   chart &&
          //   (chart.renderTo.id === 'halfPieChartId0' ||
          //     chart.renderTo.id === 'halfPieChartId1' ||
          //     chart.renderTo.id === 'powerChartId')
          // ) {
          //   chart.reflow()
          // }
        });
      });
      this.resizeObserver.observe(this.$refs.viewRef);
    },
    clearPowerDataAndChart: function clearPowerDataAndChart() {
      this.hourlyData = [];
      this.dailyData = {};
      this.pvHalfPieChartOptions.series[0].data = [null, null];
      this.powerHalfPieChartOptions.series[0].data = [null, null];
      this.powerChartOptions.xAxis.categories = [];
      this.powerChartOptions.series = [];
    },
    setPowerChart: function setPowerChart() {
      var _this = this;
      var seriesContents = [{
        name: '用電',
        dataKey: 'power'
      }, {
        name: '綠電自發自用',
        dataKey: 'selfPower'
      }, {
        name: '餘電躉售',
        dataKey: 'sellPower'
      }];
      this.powerChartOptions.xAxis.categories = this.hourlyData.map(function (o) {
        return o.time;
      });
      seriesContents.forEach(function (s) {
        _this.powerChartOptions.series.push({
          name: s.name,
          data: _this.hourlyData.map(function (o) {
            return Math.round(o[s.dataKey] * 100) / 100;
          })
        });
        // this.powerChartOptions.series[idx].name = s.name
      });
      // this.powerChartOptions.series[0].data = this.hourlyData.map(
      //   (o) => Math.round(o.power * 100) / 100
      // )
      // this.powerChartOptions.series[1].data = this.hourlyData.map(
      //   (o) => Math.round(o.selfPower * 100) / 100
      // )
      // this.powerChartOptions.series[2].data = this.hourlyData.map(
      //   (o) => Math.round(o.sellPower * 100) / 100
      // )
    },
    setHalfPieChart: function setHalfPieChart() {
      var pv = this.powerData.pv;
      var power = this.powerData.power;
      var pvDataSum = pv.greenValue + pv.utilityValue;
      this.pvHalfPieChartOptions.series[0].data = pvDataSum === 0 ? [0, 0] : [pv.greenValue / pvDataSum * 100, pv.utilityValue / pvDataSum * 100];
      var powerDataSum = power.greenValue + power.utilityValue;
      this.powerHalfPieChartOptions.series[0].data = powerDataSum === 0 ? [0, 0] : [power.greenValue / powerDataSum * 100, power.utilityValue / powerDataSum * 100];
    },
    getPowerGenPowerUsageData: function getPowerGenPowerUsageData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res, _res$data$data, _res$data$data2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.clearPowerDataAndChart();
                params = {
                  fieldName: _this2.selectedFieldName,
                  date: dayjs(_this2.selectedDate).format('YYYY-MM-DD')
                };
                _context.prev = 2;
                _context.next = 5;
                return getPowerGenPowerUsageApi(params);
              case 5:
                res = _context.sent;
                if (!res.data.success) {
                  _context.next = 13;
                  break;
                }
                if (!(res.data.msg === 'no data')) {
                  _context.next = 9;
                  break;
                }
                return _context.abrupt("return", _this2.$swal('尚無資料'));
              case 9:
                _this2.hourlyData = (_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.hourlyData;
                _this2.dailyData = (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.dailyData;
                _this2.setPowerChart();
                _this2.setHalfPieChart();
              case 13:
                _context.next = 18;
                break;
              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                console.log('getPowerGenPowerUsageData error', _context.t0);
              case 18:
                _context.prev = 18;
                // 有資料後 再設定 chart height 否則 chart height 會是 0
                _this2.resizeCharts();
                return _context.finish(18);
              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 15, 18, 21]]);
      }))();
    },
    resizeCharts: function resizeCharts() {
      var _this3 = this;
      // chart height
      this.$nextTick(function () {
        // const pieChartWrapHeight =
        //   this.$refs.pieChartWrapRef0?.[0].getBoundingClientRect().height || 0
        // const pieChartWrapWidth =
        //   this.$refs.pieChartWrapRef0?.[0].clientWidth || 0
        // console.log(
        //   'pieChartWrapHeight',
        //   pieChartWrapHeight,
        //   'pieChartWrapWidth',
        //   pieChartWrapWidth
        // )

        var viewWidth = _this3.$refs.viewRef.clientWidth;
        // console.log('power viewHeight', viewWidth)

        // 視窗 1440 時 viewWidth = 1281
        if (viewWidth > 1281) {
          var viewHeight = _this3.$refs.viewRef.clientHeight;
          // or this.$refs.viewRef.getBoundingClientRect().height

          // ----- pie chart -----
          var chartWrapHeight = (viewHeight - 382) / 2; // -datepicker -card title - padding ....
          // const chartWrapHeight1 =
          //   this.$refs.pieChartWrapRef0?.[0].clientHeight || 0
          var chartWrapWidth = 300; // card css set width 350 - card padding*2 50

          // console.log('chartWrapHeight', chartWrapHeight)
          // console.log('chartWrapHeight1', chartWrapHeight1)
          // [ chart height ]
          _this3.pvHalfPieChartOptions.chart.height = chartWrapHeight;
          _this3.powerHalfPieChartOptions.chart.height = chartWrapHeight;

          // [ chart width ]
          // 想要讓 chart 直徑 = 父層寬度 (300)
          // 半徑 300/2 不能大於 父層高度 否則 chart 超出範圍
          // 判斷 chartWrapWidth / 2 > chartWrapHeight 會超出 故用 chartWrapHeight * 2 作為直徑
          // 直徑
          var diameter = chartWrapWidth / 2 > chartWrapHeight ? chartWrapHeight * 2 * 0.8 // height*2 = 直徑 (留點空間 所以乘 0.9)
          : chartWrapWidth;
          _this3.pvHalfPieChartOptions.plotOptions.pie.size = diameter;
          _this3.powerHalfPieChartOptions.plotOptions.pie.size = diameter;

          // [ chart center ]
          // [test?] chart 塞滿 div , 外層包一個 div 給 padding
          // 半徑
          var radius = diameter / 2;
          var centerY = chartWrapHeight - (chartWrapHeight - radius) / 2;
          // console.log('centerY', centerY)
          _this3.pvHalfPieChartOptions.plotOptions.pie.center[1] = centerY - 25; // 因 centerY 0 不是在最上方 所以減 25
          _this3.powerHalfPieChartOptions.plotOptions.pie.center[1] = centerY - 25;

          // ----- line chart -----
          _this3.powerChartOptions.chart.height = viewHeight - 52; // -padding 50 -border 2

          return;
        }
        _this3.pvHalfPieChartOptions.chart.height = 310 - 25 * 2 - 48;
        _this3.powerHalfPieChartOptions.chart.height = 310 - 25 * 2 - 48;
        _this3.pvHalfPieChartOptions.plotOptions.pie.size = 302;
        _this3.powerHalfPieChartOptions.plotOptions.pie.size = 302;
        _this3.pvHalfPieChartOptions.plotOptions.pie.center[1] = '100%';
        _this3.powerHalfPieChartOptions.plotOptions.pie.center[1] = '100%';
        // this.powerHalfPieChartOptions.chart.height = 300
        // this.powerChartOptions.chart.height = 300
        _this3.powerChartOptions.chart.height = 413; // 設計稿 465 -padding 50 -border 2

        // 視窗 576 時 viewWidth = 529
        if (viewWidth <= 529) {
          _this3.pvHalfPieChartOptions.chart.height = 273 - 25 * 2 - 48;
          _this3.powerHalfPieChartOptions.chart.height = 273 - 25 * 2 - 48;
          _this3.pvHalfPieChartOptions.plotOptions.pie.size = 273;
          _this3.powerHalfPieChartOptions.plotOptions.pie.size = 273;
        }
      });
    }
  },
  created: function created() {
    window.addEventListener('resize', this.resizeCharts);

    // api
    // 有 keep alive 只進入頁面執行一次, watch 的不會執行
    this.getPowerGenPowerUsageData();
  },
  mounted: function mounted() {
    this.observeElementSize();
  },
  beforeDestroy: function beforeDestroy() {
    this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.resizeCharts);
  }
};